<sh-dropdown
  #tzDropdown
  id="time-zone-init-status"
  label="{{ 'cts.gantry.timezone' | translate }}"
  (value-changed)="onValueChanged(tzDropdown.value)"
  value="{{ selectedeTzDescription() }}"
  [error]="!isValidInput()"
  editable
>
  <sh-text class="group-text" size="title-1">
    {{ 'cts.gantry.deviceLocalTime' | translate }}
  </sh-text>
  <sh-menu-item
    id="local-time-option"
    label="{{ offsetDescription() }}"
    (click)="onDeviceLocalTimeZoneClick()"
    [active]="timeZone() === undefined"
    (keydown.enter)="onDeviceLocalTimeZoneClick()"
  ></sh-menu-item>
  <sh-divider></sh-divider>
  <sh-text class="group-text" size="title-1">
    {{ 'cts.gantry.otherTimeZones' | translate }}
  </sh-text>
  @for (tz of timeZones(); track tz.timeZone) {
    <sh-menu-item
      label="{{ tzDescription(tz) }}"
      (click)="onTimeZoneClick(tz)"
      (keydown.enter)="onTimeZoneClick(tz)"
      [active]="timeZone()?.timeZone === tz.timeZone"
    ></sh-menu-item>
  }
</sh-dropdown>
